import styled from 'styled-components'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const AudioSearchSectionContainer = styled.div<{
  $hasSearchResult: boolean
  $hasNotSearchValue: boolean
}>`
  height: ${props => (props.$hasSearchResult ? '100%' : 'auto')};
  display: flex;
  flex-direction: column;
  padding-bottom: ${props => (props.$hasNotSearchValue ? '16px' : 'auto')};
  width: 100%;
`

export const AudioSearchInputContainer = styled.div`
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    padding: 0;
  }
`
